import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';

export const getLoadingAndDoorsFiltersConfigByType = (type: string): IFilterConfigItem[] => [
  {
    title: '# Drive In Doors',
    name: `${type}_ground_door_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Drive In Door Width',
    name: `${type}_ground_level_width`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Drive In Door Height',
    name: `${type}_ground_level_height`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: '# Dock High Doors',
    name: `${type}_dock_door_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Dock High Door Width',
    name: `${type}_dock_door_width`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Dock High Door Height',
    name: `${type}_dock_door_height`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Dock Orientation',
    name: `${type}_dock_orientation`, // NEW
    items: [
      { text: 'Cross Dock', value: 'cross dock' },
      { text: 'Rear Load', value: 'rear load' },
      { text: 'Front Load', value: 'front load' },
      { text: 'Side Load', value: 'side load' },
      { text: 'Tri Load', value: 'tri load' },
    ],
    type: FilterTypeEnum.autocomplete_multiple_select,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Trailer Spots',
    name: `${type}_trailer_spot_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Min Truck Court Depth',
    name: `${type}_min_truck_court_depth`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.doors,
  },
  {
    title: 'Max Truck Court Depth',
    name: `${type}_max_truck_court_depth`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.doors,
  },
]
